import React from "react";
import { AdminPage } from "@floriscope";

function AdminExample() {
  return (
    <div className="flex flex-col flex-1 items-center justify-center p-16">
      <div className="max-w-512 text-center">
        <AdminPage></AdminPage>
      </div>
    </div>
  );
}

export default AdminExample;
